<template>
  <v-row>
    <v-col cols="12" sm="6">
      <v-text-field
        outlined
        v-model="emailAddressValue"
        :label=label
        validate-on-blur
        :disabled="disabled"
        :readonly="readOnly ? readOnly : false"
        :rules="[checkRequired(), validateEmail()]"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6">
      <v-text-field
        outlined
        v-model="confirmationEmail"
        :label="`${label} Confirmation`"
        validate-on-blur
        :disabled="disableConfirmation"
        :rules="[validateConfirmationEmail()]"
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    label: String,
    emailAddress: String,
    isRequired: Boolean,
    disabled: Boolean,
    readOnly: Boolean
  },
  emits: ['emailChange'],
  data () {
    return {
      isValid: false,
      confirmationEmail: '',
      disableConfirmation: true
    }
  },
  computed: {
    emailAddressValue: {
      get () {
        return this.emailAddress
      },
      set (newValue) {
        this.$emit('emailChange', newValue)
        this.disableConfirmation = !(newValue && newValue !== '')
      }
    }
  },
  watch: {
    emailAddress () {
      if (this.emailAddress === null) {
        this.disableConfirmation = true
        this.confirmationEmail = null
      }
    }
  },
  methods: {
    checkRequired () {
      return this.isRequired ? (this.emailAddress && this.emailAddress !== '' ? true : `${this.label} is required`) : true
    },
    validateEmail () {
      if (!this.isRequired && (!this.emailAddress || this.emailAddress === '')) {
        return true
      } else {
        return this.emailAddress && this.emailAddress.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+/) ? true : 'Please enter a valid E-mail address'
      }
    },
    validateConfirmationEmail () {
      if (!this.isRequired && (!this.emailAddress || this.emailAddress === '')) {
        return true
      } if (this.emailAddress && this.emailAddress !== '' && this.disableConfirmation) {
        return true
      } else {
        return this.confirmationEmail && this.confirmationEmail !== '' ? (this.emailAddress.toLowerCase() === this.confirmationEmail.toLowerCase() ? true : 'Email and Confirmation Email are different') : 'Please confirm the E-mail'
      }
    }
  }
}
</script>
